import { FC } from 'react';
import useBem from '@indicia/use-bem';

import { SolutionsContainerType } from '../../types';
import ThemeEmployerHelpItem from './theme-employer-help-item';
import BackgroundContainer from '../../../../shared/components/background-container/background-container';
import ThemeLink from '../theme-link/theme-link';
import useOrgUnitLogo from '../../../../shared/hooks/use-orgunit-logo';

import './theme-employer-help.scss';

const ThemeEmployerHelp: FC<SolutionsContainerType> = ({ title, description, footerText, solutions, externalLink }) => {
  const { bemClassName, bemClassNames } = useBem('theme-employer-help');
  const imageUrl = useOrgUnitLogo();

  return (
    <BackgroundContainer type="white">
      <div className={bemClassNames([bemClassName(), 'container'])}>
        <div className={bemClassName('header')}>
          <div className={bemClassName('header-logo')}>
            {imageUrl && (
              <img
                src={`${window.__RUNTIME_CONFIG__.ODATA_URL}/${imageUrl}`}
                alt=""
              />
            )}
          </div>
          <div className={bemClassName('header-content')}>
            <h3>{title}</h3>
            <p>
              {description} {externalLink && <ThemeLink {...externalLink} />}
            </p>
            {footerText && <p className="small-script">{footerText}</p>}
          </div>
        </div>
        <div className={bemClassName('item-list')}>
          {solutions.map((solution) => {
            const { title: solutionTitle } = solution;

            return (
              <ThemeEmployerHelpItem
                key={solutionTitle}
                className={bemClassName('item')}
                {...solution}
              />
            );
          })}
        </div>
      </div>
    </BackgroundContainer>
  );
};

export default ThemeEmployerHelp;
